import BannerComp from "../components/BannerComp";
import Seo from "../components/Seo";
import { SpecialCardSection } from "../components/SpecialCard";
import { cardData } from "../data/services";
import { createBreadcrumbSchema } from "../lib/seo";

const seo = {
  title: "Medical Billing & RCM Services | Physicians Success Partners",
  description:
    "Explore Physicians Success Partners' full range of medical billing, coding, denial management, and RCM services designed to improve revenue and reduce errors.",
  keywords:
    "medical billing services, denial management services, credentialing and enrollment, prior authorization services, virtual medical scribe",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Medical Billing and Revenue Cycle Management Services",
      url: "https://psprcm.us/services/",
      description:
        "Explore Physicians Success Partners' full range of medical billing, coding, denial management, and RCM services designed to improve revenue and reduce errors.",
      provider: {
        "@type": "Organization",
        name: "Physicians Success Partners",
        url: "https://psprcm.us/",
        logo: "https://psprcm.us/logo/main-logo.webp",
        telephone: "+1 6155536787",
        email: "info@psprcm.us",
        address: {
          "@type": "PostalAddress",
          streetAddress: "1616 Westgate Circle",
          addressLocality: "Brentwood",
          addressRegion: "TN",
          postalCode: "37027",
          addressCountry: "USA",
        },
      },
      areaServed: {
        "@type": "Country",
        name: "United States",
      },
      serviceType: [
        "Medical Billing",
        "Medical Coding",
        "Denial Management",
        "Credentialing & Enrollment",
        "Revenue Cycle Management",
      ],
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "RCM Services",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Medical Billing Services" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Medical Coding Services" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Denial Management Services" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Credentialing & Enrollment Services" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Virtual Assistant Service" } },
        ],
      },
    },
    createBreadcrumbSchema("/services", "Medical Billing & RCM Services"),
  ],
};

export default function Services() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/services"
        schema={seo.schema}
      />
      <BannerComp
        heading="Flexible Medical Billing Services Tailored To Your Practice"
        paragraph="Explore practical revenue cycle support designed to improve billing accuracy, reduce delays, and strengthen financial performance for healthcare teams."
        form={false}
        centered
      />

      <SpecialCardSection
        id="servicesMain"
        items={cardData}
        variant="service"
        eyebrow="Our Capabilities"
        heading="Everything You Will Need"
        description="We take great pride in offering an extensive range of services. Our comprehensive solutions ensure we meet all your needs from start to finish."
      />
    </>
  );
}
